





























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { PropertyViewModel } from "@/shared/models/property";
import { Notification } from "../../store/modules/notifications";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
import PropertyTile from "./PropertyTile.vue";
import NoData from "@/components/misc/NoData.vue";
import * as _ from "lodash";
import { Action } from "vuex-class";
import VueRouter from "vue-router";
import PropertyImport from "@/components/property/import/PropertyImport.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
const { isNavigationFailure } = VueRouter;

@Component({
  components: {
    ScrollLoader,
    PropertyTile,
    NoData,
    PropertyImport,
    RequireRole
  },
})
export default class PropertiesTiles extends Vue {
  properties: PropertyViewModel[] = [];
  loading = false;
  done = false;

  isPropertyImportOpen = false;

  tileTransition = false;

  displayBody: HTMLElement | null = null;

  itemsPerPage = 10;

  filters = {
    name: "",
    city: "",
    address: "",
  };

  @Watch("filters", { deep: true })
  filtersWatch() {
    this.clearAndLoad();
  }

  mounted() {
    this.displayBody = this.$refs.displayBody as HTMLElement;
    this.firstLoad();
  }

  clearAndLoad = _.debounce(() => {
    this.clear();
    this.firstLoad();
  }, 500);

  clear() {
    this.properties = [];
    // this.count = 0;
    this.done = false;
  }

  async fetcher() {
    this.loading = true;

    const res = await this.$http
      .get<ListModel<PropertyViewModel>>("Properties", {
        params: {
          $skip: this.properties.length,
          $top: this.itemsPerPage,
          $count: true,
          ...this.filters,
        },
      })
      .then((x) => {
        return x.data;
      });

    this.loading = false;

    if (res.result.length < this.itemsPerPage) {
      this.done = true;
    }

    return res;
  }

  async firstLoad() {
    await this.loadMore();

    if (this.displayBody) {
      // in case it can fit more than 10 items
      // try fetching a few more times to fill it up
      for (let i = 0; i < 10; i++) {
        if (
          this.displayBody.scrollHeight > 0 &&
          this.displayBody.scrollHeight == this.displayBody.clientHeight &&
          !this.done
        ) {
          await this.loadMore();
        }
      }
    }
  }

  async loadMore() {
    if (!this.loading && !this.done) {
      const res = await this.fetcher();
      this.properties.splice(this.properties.length, 0, ...(res.result || []));
    }
  }

  addProperty() {
    this.$router.push({ path: "/properties/new" });
  }

  editProperty(id: number) {
    this.tileTransition = true;
    this.$router.push({ path: `/properties/${id}` }).catch((failure) => {
      if (isNavigationFailure(failure)) {
        this.tileTransition = false;
      }
    });
  }

  // prettier-ignore
  @Action("globalFilters/refreshFilter") refreshFilter?: (replace?: boolean) => void;

  deleteProperty(item: PropertyViewModel) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("Property.DeleteConfirmation", { value: item?.name }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deletePropertyConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deletePropertyConfirm({ id }: { id: number }) {
    Vue.axios
      .delete(`/properties/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Property.DeleteSuccess"),
          timeout: 5000,
        } as Notification);

        if (this.refreshFilter) {
          this.refreshFilter();
        }
      })
      .finally(() => {
        this.clearAndLoad();
      });
  }
}
